/**
 * width -> tamanho de width
 * height -> tamanho de height
 * color -> string = cor da barra
 * margin -> margem completa ex: 25px 10px 0 5px
 * isPortrait -> bool = verifica para ser retrato
 * _customClassName -> strinf = classe customizada
 */
import React from "react";
import './Divider.css'
const Divider = props => {
    const { 
        color, 
        width, 
        height, 
        margin,
        isPortrait,
        _customClassName
    } = props
    return (
        <div className={`divider ${isPortrait && 'divider-portrait'} ${_customClassName}`} style={{
            ...(color ? { backgroundColor: color } : {}),
            ...(width ? { width } : {}),
            ...(height ? { height } : {}),
            ...(margin ? { margin } : {}),

        }} />
    )
}

export default Divider